import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { withRouter } from 'react-router-dom';

import { withStyles } from '@material-ui/core/styles';
import {Grid, Icon, IconButton, Menu, MenuItem, Checkbox} from '@material-ui/core';
import UploadFileDialog from '../../upload/uploadDialog.component';
import SessionItemComponent from './sessionItem.component';

const styles = theme => ({
  noSessions: {
    padding: '50px',
  },
  rightIcon: {
    marginLeft: theme.spacing.unit,
  },
  button: {
    margin: '50px 50px 0px',
    padding: '15px 40px',
  },
  toolbarright: {
    display: 'flex',
  },
  buttonRight: {
    marginLeft: 'auto',
    marginRight: '0px'
  }
});

class SessionListComponent extends React.Component {
  constructor(props) {
    super(props);

    this.renderSessionItems = this.renderSessionItems.bind(this);
    this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
    this.state = {
      anchorEl: null,
      isFetching: true,
      hideArchivedSessions: true
    }
  }

  componentDidMount(){
    if(!this.props.settings) {
      this.props.refreshSettings()
    }
    const settings = this.props.settings;
    this.setState({
      isFetching: false,
      hideArchivedSessions: settings.hideArchivedSessions
    })

  }

  renderSessionItems() {
    const { classes, settings } = this.props;
    //.filter((session) => session.hide !== true).
    const sessions =  settings.hideArchivedSessions
      ? Object.values(this.props.sessions).filter(session => session.hide === false).sort((a, b) => b.lastModified - a.lastModified)
      : Object.values(this.props.sessions).sort((a, b) => b.lastModified - a.lastModified)

    return _.map(sessions, (session, key) => (
      <SessionItemComponent
        className={classes.marginBottomExpanded}
        session={session}
        key={key}
        currentSessionId={this.props.currentSessionId}
        currentFileId={this.props.currentFileId}
        hideSession={this.props.hideSession}
      />
    ));
  }

  handleMenuClick = event => {
    this.setState({ anchorEl: event.currentTarget})
  }
  handleClose = () => {
    this.setState({anchorEl: null})
  }
  handleCheckboxChange = (event) => {
    this.setState({hideArchivedSessions: event.target.checked});
    this.props.hideArchivedSessions(event.target.checked)
  }
  render() {
    const {classes} = this.props;
    const {anchorEl, isFetching} = this.state;
    return (
      <>
        <div className={classes.toolbarright}>
          <IconButton className={classes.buttonRight} onClick={this.handleMenuClick}>
            <Icon>
              more_vert
            </Icon>
          </IconButton>
          <Menu
            onClose={this.handleClose}
            open={Boolean(anchorEl)}
            anchorEl={anchorEl}>
            <MenuItem>
              Hide archived sessions <Checkbox checked={this.state.hideArchivedSessions} onChange={this.handleCheckboxChange}></Checkbox>
            </MenuItem>
          </Menu>
        </div>
        <Grid container spacing={32}>
        {isFetching?'': this.renderSessionItems()}
        <UploadFileDialog refreshSessions={this.props.refreshSessions}/>
        </Grid>
      </>
    );
  }
}

SessionListComponent.propTypes = {
  sessions: PropTypes.shape({
    id: PropTypes.string,
    createdAt: PropTypes.number,
    lastModified: PropTypes.number,
    name: PropTypes.string,
    hide: PropTypes.bool,
    files: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string,
      filename: PropTypes.string,
      lastModified: PropTypes.number,
      savedByUser: PropTypes.bool,
    })),
  }).isRequired,
  settings: PropTypes.shape({
    hideArchivedSessions: PropTypes.bool,
  }),
  /* eslint-disable react/forbid-prop-types */
  history: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
  /* eslint-enable */
  currentSessionId: PropTypes.string.isRequired,
  refreshSessions: PropTypes.func.isRequired,
  refreshSettings: PropTypes.func.isRequired,
  hideSession: PropTypes.func.isRequired,
  currentFileId: PropTypes.string.isRequired,
  hideArchivedSessions: PropTypes.func.isRequired,
};

export default withStyles(styles)(withRouter(SessionListComponent));
